// extracted by mini-css-extract-plugin
export var downArrow = "_7p-0";
export var label = "_7p-1";
export var treatmentCard = "_7p-3";
export var upArrow = "_7p-2";